import { Component, Input } from '@angular/core';
import { DisplayOptions, Filter } from '../../models/filter-models';
import { DisplayType } from "../../models/enums";
import { Rarity } from "../../models/enums";
import { ArmourType, WeaponType } from "../../models/enums";
import { FormsModule } from '@angular/forms';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { FilterService } from '../../services/filter.service';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';
import { ItemDataService } from '../../services/item-data.service';
import { BaseComponent } from '../../common/base.component';
import { GearTierIconComponent } from "../../common/icons/gear-tier-icon/gear-tier-icon.component";
import { ActiveRules, ActiveSpecialRules } from '../../services/filter-generator.service';
import { EquipmentType } from "../../models/equipment-type.enum";
import { excellentGearBaseTypes, goodGearBaseTypes } from '../../services/generators/poe1-crafting-bases-generator.service';
import { BaseType } from '../../models/item-data-models';
import { DynamicContentComponent } from '../../common/dynamic-content/dynamic-content.component';
import { FilterCheckboxGroupComponent } from '../../common/filter-checkbox-group/filter-checkbox-group.component';
import { JewelleryTierService } from '../../services/tiering/jewellery-tier.service';

@Component({
  selector: 'app-crafting-base-filters-poe1',
  imports: [FormsModule, AutocompleteComponent, FilterTitleComponent, EquipmentTierPickerComponent,
    GearTierIconComponent, DynamicContentComponent, FilterCheckboxGroupComponent],
  templateUrl: './crafting-base-filters-poe1.component.html',
  styleUrl: './crafting-base-filters-poe1.component.scss'
})
export class CraftingBaseFiltersPoe1Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  craftingBaseWeaponClasses: { name: WeaponType, image: string }[] = [];
  armourTypes: { name: ArmourType, image: string }[] = [];
  defenceTypes = [
    { name: 'Arm', image: '/img/shields/shield-red.png' },
    { name: 'Eva', image: '/img/shields/shield-green.png' },
    { name: 'ES', image: '/img/shields/shield-blue.png' },
    { name: 'Arm/Eva', image: '/img/shields/shield-red-green.png' },
    { name: 'Arm/ES', image: '/img/shields/shield-red-blue.png' },
    { name: 'Eva/ES', image: '/img/shields/shield-green-blue.png' }
  ];

  excellentGearBaseTypes: string[] = excellentGearBaseTypes;
  goodGearBaseTypes: string[] = goodGearBaseTypes;
  excellentJewelleryBaseTypes: string[] = [];
  goodJewelleryBaseTypes: string[] = [];
  specialJewelleryBaseTypes: string[] = [];
  allOtherSpecialJewelleryBaseTypesTypes: BaseType[] = [];
  firstOtherSpecialJewelleryBaseType: string = '';
  utilityPlusTopLifeManaFlaskTypes: BaseType[] = [];

  Rarity = Rarity;
  DisplayType = DisplayType;
  EquipmentType = EquipmentType;

  constructor(private filterService: FilterService, private itemDataService: ItemDataService, jewelleryTierService: JewelleryTierService) {
    super();

    const jewelleryTierData = jewelleryTierService.getJewelleryTierData();
    this.excellentJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Excellent').map(j => j.name);
    this.goodJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Good').map(j => j.name);
    this.specialJewelleryBaseTypes = jewelleryTierData.filter(j => j.tier === 'Special').map(j => j.name);
    const allSpecialJewelleryBaseTypes = this.specialJewelleryBaseTypes;

    this.allOtherSpecialJewelleryBaseTypesTypes = this.itemDataService.getItemData().find(i => i.itemType === 'Amulets')!.baseTypes
      .concat(this.itemDataService.getItemData().find(i => i.itemType === 'Rings')!.baseTypes)
      .concat(this.itemDataService.getItemData().find(i => i.itemType === 'Belts')!.baseTypes)
      .filter(b => [...allSpecialJewelleryBaseTypes].includes(b.name));

    this.firstOtherSpecialJewelleryBaseType = this.allOtherSpecialJewelleryBaseTypesTypes.filter(b => ![...this.excellentJewelleryBaseTypes, ...this.goodJewelleryBaseTypes].includes(b.name))[0]?.name || 'Example Jewellery';

    this.craftingBaseWeaponClasses = this.itemDataService.getAllWeaponTypes()
      .filter(w => w !== WeaponType.Quivers)
      .map(w => ({ name: w as WeaponType, image: this.itemDataService.getItemData().find(i => i.itemClass === w)!.baseTypes[0].image! }));
    this.armourTypes = [
      { name: ArmourType.BodyArmours, image: this.itemDataService.getItemData().find(i => i.itemClass === ArmourType.BodyArmours)!.baseTypes[1].image! },
      { name: ArmourType.Helmets, image: this.itemDataService.getItemData().find(i => i.itemClass === ArmourType.Helmets)!.baseTypes[6].image! },
      { name: ArmourType.Gloves, image: this.itemDataService.getItemData().find(i => i.itemClass === ArmourType.Gloves)!.baseTypes[1].image! },
      { name: ArmourType.Boots, image: this.itemDataService.getItemData().find(i => i.itemClass === ArmourType.Boots)!.baseTypes[1].image! },
      { name: ArmourType.Shields, image: this.itemDataService.getItemData().find(i => i.itemClass === ArmourType.Shields)!.baseTypes[0].image! },
    ];

    const itemData = this.itemDataService.getItemData();
    this.utilityPlusTopLifeManaFlaskTypes = itemData.find(i => i.itemType === 'Utility Flasks')!.baseTypes
      .concat(itemData.find(i => i.itemType === 'Tinctures')!.baseTypes)
      .concat([
        { name: 'Divine Life Flask', image: '/img/gear/flasks/lifeflask11.webp' },
        { name: 'Eternal Life Flask', image: '/img/gear/flasks/lifeflask12.webp' },
        { name: 'Divine Mana Flask', image: '/img/gear/flasks/manaflask11.webp' },
        { name: 'Eternal Mana Flask', image: '/img/gear/flasks/manaflask12.webp' },
      ]);
  }

  toggleHighlight(displayOptions: DisplayOptions) {
    displayOptions.active = !displayOptions.active;
  }

  toggleHighlightExcellentWeaponCraftingBases = () => {
    this.filter.showExcellentWeaponCraftingBases = !this.filter.showExcellentWeaponCraftingBases;
    if (!this.filter.showExcellentWeaponCraftingBases) {
      this.filter.showGoodWeaponCraftingBases = false;
    }
    this.updateFilter();
  }

  highlightWeaponCraftingBasesClassesChanged(newValues: string[]) {
    this.filter.showWeaponCraftingBasesClasses = newValues as WeaponType[];
    this.updateFilter();
  }

  toggleHighlightExcellentArmourCraftingBases = () => {
    this.filter.showExcellentArmourCraftingBases = !this.filter.showExcellentArmourCraftingBases;
    if (!this.filter.showExcellentArmourCraftingBases) {
      this.filter.showGoodArmourCraftingBases = false;
    }
    this.updateFilter();
  }

  highlightArmourCraftingBasesTypesChanged(newValues: string[]) {
    this.filter.showArmourCraftingBasesTypes = newValues as ArmourType[];
    this.updateFilter();
  }

  toggleHighlightExcellentGearBaseTypes = () => {
    this.filter.showExcellentGearBaseTypes = !this.filter.showExcellentGearBaseTypes;
    if (!this.filter.showExcellentGearBaseTypes) {
      this.filter.showGoodGearBaseTypes = false;
    }
    this.updateFilter();
  }

  toggleHighlightExcellentJewelleryBaseTypes = () => {
    this.filter.showExcellentJewelleryBaseTypes = !this.filter.showExcellentJewelleryBaseTypes;
    if (!this.filter.showExcellentJewelleryBaseTypes) {
      this.filter.showGoodJewelleryBaseTypes = false;
    }
    this.updateFilter();
  }

  toggleHighlightOtherSpecialJewelleryBaseTypes = () => {
    this.filter.showOtherSpecialJewelleryBaseTypes = !this.filter.showOtherSpecialJewelleryBaseTypes;
    this.updateFilter();
  }

  highlightOtherSpecialJewelleryBaseTypesTypesChanged(newValues: string[]) {
    this.filter.showOtherSpecialJewelleryBaseTypesTypes = newValues;
    this.updateFilter();
  }

  toggleHighlightExcellentQualityFlasks = () => {
    this.filter.showExcellentQualityFlasks = !this.filter.showExcellentQualityFlasks;
    if (!this.filter.showExcellentQualityFlasks) {
      this.filter.showGoodQualityFlasks = false;
    }
    this.updateFilter();
  }

  toggleHighlightHighILevelFlasks = () => { this.filter.showHighILevelFlasks = !this.filter.showHighILevelFlasks; this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
